import { c as _c } from "react/compiler-runtime";
import { IcoEye16, IcoEyeCrossed16, IcoSparkles16 } from '@onefootprint/icons';
import { Button, IconButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type PercyFooterProps = {
  note: string;
  isStale?: boolean;
  onAccept?: () => void;
  onDismiss?: () => void;
  isPending?: boolean;
  showDiffToggle?: boolean;
  showDiff?: boolean;
  onToggleDiff?: (checked: boolean) => void;
};
const PercyFooter = t0 => {
  const $ = _c(32);
  const {
    note,
    isStale,
    onAccept,
    onDismiss,
    isPending,
    showDiffToggle,
    showDiff,
    onToggleDiff
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.suggestion"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IcoSparkles16 color="tertiary" className="w-3 h-3" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== note) {
    t3 = <span className="text-caption-4 text-tertiary">{note}</span>;
    $[2] = note;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onToggleDiff || $[5] !== showDiff || $[6] !== showDiffToggle || $[7] !== t) {
    t4 = showDiffToggle && <IconButton aria-label={t(_temp)} aria-pressed={showDiff} size="tiny" variant="ghost" icon={showDiff ? IcoEye16 : IcoEyeCrossed16} color={showDiff ? "accent" : "quaternary"} onClick={() => onToggleDiff?.(!showDiff)} />;
    $[4] = onToggleDiff;
    $[5] = showDiff;
    $[6] = showDiffToggle;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isStale || $[10] !== t) {
    t5 = isStale && <span className="text-caption-4 text-warning ml-1">⚠ {t(_temp2)}</span>;
    $[9] = isStale;
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t(_temp3);
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isPending || $[15] !== onDismiss || $[16] !== t6) {
    t7 = <Button variant="secondary" size="compact" onClick={onDismiss} disabled={isPending}>{t6}</Button>;
    $[14] = isPending;
    $[15] = onDismiss;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = isStale || isPending;
  let t9;
  if ($[18] !== t) {
    t9 = t(_temp4);
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== onAccept || $[21] !== t8 || $[22] !== t9) {
    t10 = <Button variant="primary" size="compact" onClick={onAccept} disabled={t8}>{t9}</Button>;
    $[20] = onAccept;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t7) {
    t11 = <div className="ml-auto flex items-center gap-2">{t7}{t10}</div>;
    $[24] = t10;
    $[25] = t7;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5) {
    t12 = <div className="flex flex-wrap items-center gap-2 pt-2 mt-1 border-t border-accent/20 md:flex-nowrap">{t2}{t3}{t4}{t5}{t11}</div>;
    $[27] = t11;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  return t12;
};
export default PercyFooter;
function _temp($) {
  return $.highlightChanges;
}
function _temp2($_0) {
  return $_0.stale;
}
function _temp3($_1) {
  return $_1.buttons.dismiss;
}
function _temp4($_2) {
  return $_2.buttons.accept;
}